import { cn } from '@/utils/cn';
import React from 'react';

interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, checked, onCheckedChange, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onCheckedChange?.(e.target.checked);
      onChange?.(e);
    };

    return (
      <label className={cn('relative inline-flex items-center cursor-pointer', className)}>
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={handleChange}
          ref={ref}
          {...props}
        />
        <div
          className={cn(
            'relative w-11 h-6 rounded-full transition-colors duration-200 ease-in-out',
            'focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-offset-2',
            checked ? 'bg-blue-600' : 'bg-gray-300 dark:bg-gray-600',
            props.disabled && 'cursor-not-allowed opacity-50'
          )}
        >
          <div
            className={cn(
              'absolute top-[2px] left-[2px] bg-white rounded-full h-5 w-5',
              'transition-transform duration-200 ease-in-out',
              checked && 'translate-x-5'
            )}
          />
        </div>
      </label>
    );
  }
);

Switch.displayName = 'Switch';

export { Switch };
export default Switch;
